import { render } from "./Jumbo.vue?vue&type=template&id=1c466f5e&scoped=true"
import script from "./Jumbo.vue?vue&type=script&lang=js"
export * from "./Jumbo.vue?vue&type=script&lang=js"

import "./Jumbo.vue?vue&type=style&index=0&id=1c466f5e&scoped=true&lang=scss"

import exportComponent from "E:\\Old Files\\Projecten Web\\Q-Mobile\\frame\\q-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c466f5e"]])

export default __exports__